import { render, staticRenderFns } from "./ActionTableShowSubmerchant.vue?vue&type=template&id=14160844&scoped=true&"
import script from "./ActionTableShowSubmerchant.vue?vue&type=script&lang=js&"
export * from "./ActionTableShowSubmerchant.vue?vue&type=script&lang=js&"
import style0 from "./ActionTableShowSubmerchant.vue?vue&type=style&index=0&id=14160844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14160844",
  null
  
)

export default component.exports